import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import { useNavigate } from "react-router-dom";
import personImg from "./assets/person.svg";

const patternBg = `${process.env.PUBLIC_URL}/pattern.svg`;

const softPulse = keyframes`
  0% {
    opacity: 0.18;
    transform: translateX(-50%) scale(1);
  }
  50% {
    opacity: 0.1;
    transform: translateX(-50%) scale(0.9);
  }
  100% {
    opacity: 0.18;
    transform: translateX(-50%) scale(1);
  }
`;

const Funeral404Page: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#F4E9DE",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: { xs: "24%", md: "26%" },
          left: "50%",
          transform: "translateX(-50%)",
          width: { xs: "320px", sm: "500px", md: "760px" },
          height: { xs: "160px", sm: "220px", md: "260px" },
          zIndex: 1,
        }}
      >
        <Typography
          sx={{
            position: "absolute",
            inset: 0,
            fontFamily: "Mulish, sans-serif",
            fontWeight: 1000,
            fontSize: { xs: "8rem", sm: "11rem", md: "401.59px" },
            lineHeight: { xs: 1, sm: 1, md: "94.77px" },
            letterSpacing: "0%",
            textAlign: "center",
            userSelect: "none",
            background:
              "linear-gradient(360deg, #614438 -132.33%, rgba(255, 255, 255, 0) 110.11%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          404
        </Typography>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 3,
            pointerEvents: "none",
            background: `
      linear-gradient(
        to bottom,
        rgba(244, 233, 222, 1) 0%,
        rgba(244, 233, 222, 0.88) 10%,
        rgba(244, 233, 222, 0.55) 18%,
        rgba(244, 233, 222, 0.18) 28%,
        rgba(244, 233, 222, 0) 38%
      )
    `,
          }}
        />
        <Box
          component="img"
          src={personImg}
          alt="Seated silhouette"
          sx={{
            position: "absolute",
            left: { xs: "31.5%", sm: "33.2%", md: "28.7%" },
            top: { xs: "45.8%", sm: "46.8%", md: "25%" },
            width: { xs: 34, sm: 42, md: 52 },
            height: "auto",
            zIndex: 4,
            transformOrigin: "center bottom",
            filter: "drop-shadow(0px 3px 8px rgba(0,0,0,0.16))",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            left: { xs: "33.8%", sm: "35.5%", md: "36.2%" },
            top: { xs: "63.8%", sm: "64.8%", md: "65.5%" },
            width: { xs: 20, sm: 26, md: 30 },
            height: 8,
            borderRadius: "50%",
            background: "rgba(0,0,0,0.10)",
            filter: "blur(5px)",
            zIndex: 3,
            animation: `${softPulse} 3s ease-in-out infinite`,
          }}
        />
      </Box>
      {/* Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 4,
          mt: { xs: 18, sm: 22, md: 30 },
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            color: "#1F1A17",
            fontSize: { xs: "1.2rem", md: "1.3rem" },
            fontWeight: 700,
            mb: 4,
          }}
        >
          You are not alone. Let’s go back Home
        </Typography>

        <Button
          onClick={() => navigate("/")}
          variant="contained"
          disableElevation
          sx={{
            backgroundColor: "#6E4A3A",
            color: "#fff",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "1.1rem",
            px: 4.5,
            py: 1.6,
            borderRadius: "12px",
            minWidth: 160,
            "&:hover": {
              backgroundColor: "#5D3D30",
            },
          }}
        >
          Go Home
        </Button>
      </Box>

      {/* Bottom pattern */}
      <Box
        component="img"
        src={patternBg}
        alt="Background pattern"
        sx={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: { xs: "180%", sm: "150%", md: "120%" },
          maxWidth: "1650px",
          opacity: 3,
          pointerEvents: "none",
          userSelect: "none",
          zIndex: 0,
        }}
      />
    </Box>
  );
};

export default Funeral404Page;
